import { styled } from '@mui/material/styles'
import Box from '@mui/material/Box'

const ModalContent = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
}))

export default ModalContent
